/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Land_Documents_HintInputs */

const vi_grower_land_documents_hint = /** @type {(inputs: Grower_Land_Documents_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bìa đỏ, giấy chứng nhận quyền sử dụng đất và giấy tờ khác của vùng trồng — Ảnh, PDF, Word, Excel`)
};

/**

* @param {Grower_Land_Documents_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_land_documents_hint = /** @type {((inputs?: Grower_Land_Documents_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Land_Documents_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_land_documents_hint(inputs)
});